import { AppSidebar } from "@/components/app-sidebar";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { ReactNode, useEffect, useState } from "react";

import { useAuthState } from "@/context";
import MerchantPopOver from "../MerchantPopOver";
import { Label } from "../ui/label";
import { Switch } from "../ui/switch";
import { Storage } from "@/services/storage-services";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChangeEnv } from "@/services/Settings.service";
import { getMerchant } from "@/services/Home.service";
import { ToastMessage, type } from "@/lib/toastr";
const DashboardLayout = ({
  children,
}: Readonly<{
  children: ReactNode;
}>) => {
  const [open, setOpen] = useState(false);

  const { useCurrencies, state } = useAuthState();
  const { refetch } = useCurrencies();
  const [mode, setMode] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const queryClient = useQueryClient();
  const changeEnv = async (value) => {
    const v = value === false ? "test" : "live";
    setMode(v);
    setIsLoading(true);

    mutation.mutate({
      env: v,
    });
  };

  const mutation = useMutation({
    mutationFn: (data) => ChangeEnv(data),
    mutationKey: ["env"],
    onSuccess: (res) => {
      queryClient.refetchQueries();
      if (res.status === 200) {
        getMerchant()
          .then(async (r) => {
            const selectedMerchantNew = state?.merchant;
            selectedMerchantNew["env"] = mode;

            await Storage.setItem("teams", r?.data?.data?.teams);
            await Storage.setItem("merchant", selectedMerchantNew);
            await Storage.setItem("env", mode);
          })
          .catch((er) => {
            setIsLoading(false);
            ToastMessage(type.ERROR, er?.response?.data?.message);
          });
      }
    },
    onError: (err) => {
      setIsLoading(false);
      ToastMessage(type.ERROR, err?.response?.data?.message);
    },
  });
  useEffect(() => {
    refetch();
  }, []);

  return (
    <SidebarProvider
      style={
        {
          "--sidebar-width": "248px",
        } as React.CSSProperties
      }
    >
      <AppSidebar />
      <SidebarInset>
        <header className="flex items-center h-16 gap-2 px-4 border-b shrink-0 justify-between">
          <SidebarTrigger className="-ml-1" />
          <div className="flex gap-2">
            <div className="flex items-center space-x-2 px-6">
              <Label className="text-saffron">Test</Label>
              <Switch
                onCheckedChange={changeEnv}
                defaultChecked={
                  Storage.getItem("env") === "test" ? false : true
                }
                className={
                  Storage.getItem("env") === "test" ? "" : "bg-green-2"
                }
              />
              <Label className="text-green">Live</Label>
            </div>
            <MerchantPopOver />
          </div>
        </header>
        <div>{children}</div>
      </SidebarInset>
    </SidebarProvider>
  );
};
export default DashboardLayout;
